import PubSub from "underpub-js";
import gsap from 'gsap';
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

var ListingUnitTable = function (options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingUnitTable',
	};

	$.extend(true, this.options, options);

};

ListingUnitTable.prototype.init = function () {

	var self = this;

	const urlParams = new URLSearchParams(window.location.search);

	PubSub.subscribe("Sitewide:loaded", () => {
		if (urlParams.has('filterUnits')) {
			gsap.to(window, {
				scrollTo: {
					y: self.options.$el[0],
				},
				duration: .5,
				ease: 'expo.inout',
			})
		}
	});

	//hide the column "Floor" if it's all empty
	const $columnFloor = self.options.$el.find(`[data-property="floor"]`);
	
	// Skip the first element (heading) and check only the rows
	const allEmpty = $columnFloor.slice(1).toArray().every(el => {
		const text = $(el).text().trim();
		return text === "" || text === "-";
	});
	if (allEmpty) {
		
		$columnFloor.hide();
		self.options.$el.find('.mol-ListingUnitTable__chart').addClass(`mol-ListingUnitTable__chart--noFloor`);
		
	} else {
		$columnFloor.show();
	}


};

export default ListingUnitTable;
